import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const ContactForm = ({ variant = "page" }) => {
  const [values, setValues] = useState({ nom: "", prenom: "", email: "", telephone: "", message: "" });
  const [errors, setErrors] = useState({});
  const [sending, setSending] = useState(false);

  const set = (field) => (e) => {
    setValues((v) => ({ ...v, [field]: e.target.value }));
    setErrors((err) => ({ ...err, [field]: undefined }));
  };

  const validate = () => {
    const err = {};
    if (!values.nom.trim() || values.nom.trim().length < 2) err.nom = "Veuillez indiquer votre nom.";
    if (!EMAIL_RE.test(values.email)) err.email = "Veuillez indiquer une adresse e-mail valide.";
    if (!values.message.trim() || values.message.trim().length < 10)
      err.message = "Décrivez votre besoin en quelques mots (10 caractères minimum).";
    return err;
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    const err = validate();
    setErrors(err);
    if (Object.keys(err).length > 0) return;
    setSending(true);
    try {
      await axios.post(`${API}/contact`, values);
      toast.success("Votre demande a bien été envoyée. Je vous réponds personnellement.", {
        duration: 6000,
      });
      setValues({ nom: "", prenom: "", email: "", telephone: "", message: "" });
    } catch {
      toast.error("Une erreur est survenue. Réessayez ou contactez-moi directement au 06 03 27 46 10.");
    } finally {
      setSending(false);
    }
  };

  return (
    <form onSubmit={onSubmit} noValidate data-testid="contact-form" className="space-y-6">
      <div className="grid sm:grid-cols-2 gap-6">
        <div>
          <label htmlFor="nom" className="field-label">Nom</label>
          <input
            id="nom"
            type="text"
            value={values.nom}
            onChange={set("nom")}
            placeholder="nom"
            data-testid="contact-input-nom"
            className="field"
          />
          {errors.nom && <p className="mt-2 text-xs text-vermilion" data-testid="contact-error-nom">{errors.nom}</p>}
        </div>
        <div>
          <label htmlFor="prenom" className="field-label">Prénom</label>
          <input
            id="prenom"
            type="text"
            value={values.prenom}
            onChange={set("prenom")}
            placeholder="prénom"
            data-testid="contact-input-prenom"
            className="field"
          />
        </div>
        <div>
          <label htmlFor="telephone" className="field-label">Téléphone <span className="normal-case tracking-normal">(optionnel)</span></label>
          <input
            id="telephone"
            type="tel"
            value={values.telephone}
            onChange={set("telephone")}
            placeholder="téléphone"
            data-testid="contact-input-telephone"
            className="field"
          />
        </div>
        <div>
          <label htmlFor="email" className="field-label">E-mail</label>
          <input
            id="email"
            type="email"
            value={values.email}
            onChange={set("email")}
            placeholder="e-mail"
            data-testid="contact-input-email"
            className="field"
          />
          {errors.email && <p className="mt-2 text-xs text-vermilion" data-testid="contact-error-email">{errors.email}</p>}
        </div>
      </div>

      <div>
        <label htmlFor="message" className="field-label">Votre demande</label>
        <textarea
          id="message"
          rows={6}
          value={values.message}
          onChange={set("message")}
          placeholder="Décrivez votre besoin en quelques lignes : une lettre à corriger, un CV à améliorer, un manuscrit à relire…"
          data-testid="contact-input-message"
          className="field resize-y"
        />
        {errors.message && <p className="mt-2 text-xs text-vermilion" data-testid="contact-error-message">{errors.message}</p>}
      </div>

      <button
        type="submit"
        disabled={sending}
        data-testid="contact-submit-button"
        className="btn-primary w-full sm:w-auto disabled:opacity-60 disabled:cursor-wait"
      >
        {sending ? "Envoi en cours…" : "Envoyer"}
      </button>
    </form>
  );
};
